import { Component } from '@angular/core';
import { TableViewFiltersInterfaceComponent } from './tableViewFiltersInterfaceComponent';

@Component({
  template: '',
  standalone: false,
})
export abstract class TableViewFiltersAbstractComponent
  implements TableViewFiltersInterfaceComponent
{
  public options: any;

  abstract getFilters(): any;

  constructor() {}
}
